import FlightPreferredAirline from './flight-preferred-airline-component';

import './flight-preferred-airline.scss';

const MODULE_NAME = 'app.common.preferred-airline';
const module = angular.module(MODULE_NAME, [])
    .directive(FlightPreferredAirline.DIRECTIVE_NAME, FlightPreferredAirline);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/flight-preferred-airline/flight-preferred-airline-module.js